import { FormikProps } from "formik";
import { useState } from "react";
import { useDebouncedCallback } from "use-debounce";
import styles from "./InputWithSearch.module.css";

export default <T,>({ name, formik, debouncedOnChange, searchResult, showNewLabel, placeholder, onSelectItem, onValueChange }: IInputWithSearchProps<T>) => {
    const [isInputInFocus, setIsInputInFocus] = useState(false);
    const debouncedOnChangeCallback = useDebouncedCallback(debouncedOnChange, 500);
    const value = (formik.values[name] as string) || "";

    return (
        <div className={styles.container}>
            <input
                name={name as string}
                value={value}
                placeholder={placeholder}
                onChange={e => {
                    const value = e.target.value || null;
                    formik.setFieldValue(name as string, value);
                    onValueChange?.(value);
                    debouncedOnChangeCallback(value || "");
                }}
                onFocus={_ => setIsInputInFocus(true)}
                onBlur={e => {
                    formik.handleBlur(e);
                    setIsInputInFocus(false);
                }}
                className={styles.input}
            />
            {showNewLabel && !isInputInFocus && value && value === searchResult.query && !searchResult.items.includes(value) && (
                <div className={styles.newIcon}>New</div>
            )}
            {isInputInFocus && value === searchResult.query && !!searchResult.items.length && (
                <div className={styles.searchResult}>
                    {searchResult.items.map(c => (
                        <div key={c} className={styles.searchResultItem} onMouseDown={() => {
                            formik.setFieldValue(name as string, c);
                            onSelectItem?.(c);
                            debouncedOnChange(c);
                        }}>{c}</div>
                    ))}
                </div>
            )}
        </div>
    );
};

interface IInputWithSearchProps<T> {
    name: keyof T;
    formik: FormikProps<T>;
    debouncedOnChange: (value: string) => void;
    searchResult: ISearchResult;
    showNewLabel?: boolean;
    placeholder?: string;
    onSelectItem?: (item: string) => void;
    onValueChange?: (value: string | null) => void;
}

interface ISearchResult {
    query: string;
    items: string[];
}
